export default __webpack_public_path__ + "static/media/pametni-algoritmi.f8870db7.gif";